// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2ZMpM","signatureButtonsRight":"ModalSign_signatureButtonsRight__GYQqa"};